module.exports = __webpack_public_path__ + "static/media/question.a29b5ac3.png";